const routesConfig = [
  {
    name: '顾客资产',
    shortName: '资产',
    path: '/intelligent-marketing/asset-health',
    authId: 99,
    icon: 'iconzichanjiankangdu',
    routes: [
      {
        name: '资产健康度',
        path: '/intelligent-marketing/asset-health/view',
        authId: 110,
        // icon: 'iconzichan',
      },
    ],
  },
  {
    name: '应用中心',
    shortName: '应用',
    path: '/app-center',
    authId: 1,
    icon: 'iconyunchayingyongzhongxin',
    routes: [
      {
        name: '首页概览',
        path: '/retail/home/data-dashboard',
        authId: 1216,
      },
      {
        name: '商品',


        path: '/app-center/commodity',
        authId: 3,
        // icon: 'iconyunchashangpin',
        routes: [
          {
            name: '商户商品管理',
            path: '/app-center/commodity/commodity-admin',
            authId: 10,
          },
          {
            name: '门店商品管理',
            path: '/app-center/commodity/store-commodity-admin',
            authId: 1130,
          },
          {
            name: '分类管理',
            path: '/app-center/commodity/commodity-class',
            authId: 11,
          },
          {
            name: '商品规则管理',
            path: '/app-center/commodity/commodity-rules',
            authId: 12,
          },
          {
            name: '商品标签管理',
            path: '/app-center/commodity/tags-admin',
            authId: 1226,
          },
           {
            name: '商品评价',
            path: '/app-center/commodity/comment-admin',
            authId: 2161,
          },
        ],
      },
      {
        name: '门店',
        path: '/app-center/store',
        authId: 4,
        // icon: 'iconyunchamendian',
        routes: [
          {
            name: '组织机构管理',
            path: '/app-center/store/organization',
            authId: 1151,
          },
          {
            name: '门店管理',
            path: '/app-center/store/store-admin',
            authId: 13,
          },
          {
            name: '门店业务管理',
            path: '/app-center/store/store-setting',
            authId: 15,
          },
          {
            name: '门店码',
            path: '/app-center/store/store-code',
            authId: 1155,
          },
          {
            name: '进店规则管理',
            path: '/app-center/store/store-rule',
            authId: 1195,
          }
        ],
      },
      {
        name: '订单',
        path: '/app-center/order',
        authId: 5,
        // icon: 'iconyunchadingdan',
        routes: [
          {
            name: '退款',
            path: '/app-center/order/refund',
            authId: 16,
          },
          {
            name: '订单',
            path: '/app-center/order/list',
            authId: 17,
          },
          {
            name: '售后规则',
            path: '/app-center/order/after-sale-setting',
            authId: 18,
          },
          {
            name: '售后记录',
            path: '/app-center/order/after-sale-list',
            authId: 19,
          },
          {
            name: '报表',
            path: '/app-center/order/report',
            authId: 20,
          },
          {
            name: '订单规则设置',
            path: '/app-center/order/order-rule-setting',
            authId: 21,
          },
        ],
      },
      {
        name: '会员',
        authId: 6,
        path: '/app-center/member',
        // icon: 'iconyunchahuiyuan',
        routes: [
          {
            name: '会员配置',
            path: '/app-center/member/member-setting',
            authId: 22,
          },
          {
            name: '会员管理',
            path: '/app-center/member/member-admin',
            authId: 23,
          },
          // {
          //   name: '付费会员',
          //   path: '/app-center/member/member-paid',
          //   authId: 24,
          // },
        ],
      },
      {
        name: '应用管理',
        authId: 7,
        path: '/app-center/application',
        // icon: 'iconyunchayingyong',
        routes: [
          {
            name: '我的应用',
            path: '/app-center/application/user-app',
            authId: 25,
          },
          {
            name: '应用商城',
            path: '/app-center/application/app-market',
            authId: 26,
          },
        ],
      },
      {
        name: '互动营销',
        authId: 120,
        path: '/app-center/minigame',
        // icon: 'iconyunchayingyong',
        routes: [
          {
            name: '营销游戏',
            path: '/app-center/minigame/template',
            authId: 121,
          },
          {
            name: '奖品管理',
            path: '/app-center/minigame/reward',
            authId: 122,
          },
          {
            name: '参与记录',
            path: '/app-center/minigame/log',
            authId: 123,
          },
          {
            name: '群发短信',
            path: '/app-center/minigame/sms',
            authId: 1276,
          },
        ],
      },
      {
        name: '小程序',
        authId: 9,
        path: '/app-center/miniprogram',
        routes: [
          {
            name: '小程序配置',
            path: '/retail/mini-program',
            authId: 124,
          },
          {
            name: '模板自定义',
            path: '/retail/customer-page/list',
            authId: 125,
          },
        ],
        // icon: 'iconyunchaxiaochengxu',
      },
    ],
  },
  {
    name: '人群管理',
    shortName: '人群',
    path: '/intelligent-marketing/crowd',
    authId: 96,
    icon: 'iconrenqunguanli',
    routes: [
      {
        name: '人群列表',
        authId: 105,
        path: '/intelligent-marketing/crowd/list',
        // icon: 'iconrenqunliebiao',
      },
    ],
  },
  {
    name: '标签管理',
    shortName: '标签',
    path: '/intelligent-marketing/tag',
    authId: 97,
    icon: 'iconbiaoqianguanli',
    routes: [
      {
        name: '用户标签',
        authId: 106,
        path: '/intelligent-marketing/tag/user',
        // icon: 'iconyonghubiaoqian',
      },
    ],
  },
  {
    name: '智能营销',
    shortName: '营销',
    path: '/intelligent-marketing/marketing',
    authId: 98,
    icon: 'iconzhinengyingxiao',
    routes: [
      {
        name: '营销计划',
        path: '/intelligent-marketing/marketing/activity-manage',
        authId: 107,
        // icon: 'iconyingxiaojihua',
        routes: [
          {
            name: '创建计划',
            authId: 108,
            path: '/intelligent-marketing/marketing/activity-manage/create',
          },
          {
            name: '管理计划',
            authId: 109,
            path: '/intelligent-marketing/marketing/activity-manage/manage',
          },

        ],
      },
    ],
  },
  // {
  //   name: '智慧导购',
  //   shortName: '导购',
  //   path: '/guider',
  //   authId: 1160,
  //   icon: 'iconqiweizhushou',
  //   routes: [
  //     {
  //       name: '首页',
  //       path: '/guider/statistics/home',
  //       authId: 1184,
  //     },
  //     {
  //       name: '客户运营',
  //       path: '/guider/operate',
  //       authId: 1170,
  //       routes: [
  //         {
  //           name: '欢迎语',
  //           authId: 1171,
  //           path: '/guider/operate/welcome',
  //         },
  //         {
  //           name: '客户管理',
  //           authId: 1172,
  //           path: '/guider/operate/customerManagement',
  //         },
  //         {
  //           name: '客户群管理',
  //           authId: 1173,
  //           path: '/guider/operate/customerGroupManagement',
  //         },
  //         {
  //           name: '渠道管理',
  //           authId: 1212,
  //           path: '/guider/operate/channelManagement',
  //         },
  //         {
  //           name: '群发消息',
  //           authId: 1174,
  //           path: '/guider/operate/massMessaging',
  //         },
  //         {
  //           name: '员工活码',
  //           authId: 1206,
  //           path: '/guider/operate/employeeLiveCode',
  //         },
  //         {
  //           name: '客户群活码',
  //           authId: 1207,
  //           path: '/guider/operate/customerGroupLiveCode',
  //         },
  //         {
  //           name: '门店活码',
  //           authId: 1208,
  //           path: '/guider/operate/storeCode',
  //         },
  //         {
  //           name: '在职继承',
  //           authId: 1220,
  //           path: '/guider/operate/extendsInService',
  //         },
  //         {
  //           name: '离职继承',
  //           authId: 1221,
  //           path: '/guider/operate/extendsOutService',
  //         },
  //       ],
  //     },
  //     {
  //       name: '标签管理',
  //       path: '/guider/customerTags',
  //       authId: 1204,
  //       routes: [
  //         {
  //           name: '企业标签',
  //           authId: 1205,
  //           path: '/guider/customerTags/enterpriseTag',
  //         },
  //         {
  //           name: '客户群标签',
  //           authId: 1211,
  //           path: '/guider/customerTags/groupTag',
  //         },
  //         {
  //           name: '标签建群',
  //           authId: 1213,
  //           path: '/guider/customerTags/tagMakeGroup',
  //         },
  //       ]
  //     },
  //     {
  //       name: '导购管理',
  //       path: '/guider/guiderManage',
  //       authId: 1161,
  //       // icon: 'iconyingxiaojihua',
  //       routes: [
  //         {
  //           name: '导购管理',
  //           authId: 1162,
  //           path: '/guider/guiderManage/manage',
  //         },
  //         {
  //           name: '等级日志',
  //           authId: 1192,
  //           path: '/guider/guiderManage/levelLog',
  //         },
  //         {
  //           name: '导购激励',
  //           authId: 1185,
  //           path: '/guider/guiderManage/inspire',
  //         },
  //         {
  //           name: '导购素材',
  //           authId: 1163,
  //           path: '/guider/guiderManage/material',
  //         },
  //       ],
  //     },
  //     {
  //       name: '导购任务',
  //       path: '/guider/task',
  //       authId: 1179,
  //       routes: [
  //         {
  //           name: '触达任务',
  //           authId: 1180,
  //           path: '/guider/task/mass',
  //         },
  //         // {
  //         //   name: '激励任务',
  //         //   authId: 1181,
  //         //   path: '/guider/task/reward',
  //         // },
  //       ],
  //     },
  //     {
  //       name: '导购积分',
  //       path: '/guider/guiderIntegral',
  //       authId: 1190,
  //       routes: [
  //         {
  //           name: '积分兑现',
  //           authId: 1191,
  //           path: '/guider/guiderIntegral/exchangePoints',
  //         },
  //         {
  //           name: '积分管理',
  //           authId: 1210,
  //           path: '/guider/guiderIntegral/pointsManage',
  //         },
  //       ],
  //     },
  //     {
  //       name: '素材管理',
  //       path: '/guider/publicStore',
  //       authId: 1164,
  //       // icon: 'iconyingxiaojihua',
  //       routes: [
  //         {
  //           name: '素材库',
  //           authId: 1165,
  //           path: '/guider/publicStore/index',
  //         },
  //         {
  //           name: '聊天工具栏',
  //           authId: 1165,
  //           path: '/guider/publicStore/study',
  //         },
  //       ],
  //     },
  //     {
  //       name: '活动中心',
  //       path: '/guider/activity',
  //       authId: 1193,
  //       // icon: 'iconyingxiaojihua',
  //       routes: [
  //         {
  //           name: '活动配置',
  //           authId: 1194,
  //           path: '/guider/activity/index',
  //         },
  //       ],
  //     },
  //     {
  //       name: '配置中心',
  //       path: '/guider/miniprogram',
  //       authId: 1166,
  //       // icon: 'iconyingxiaojihua',
  //       routes: [
  //         // {
  //         //   name: '组织机构',
  //         //   authId: 1167,
  //         //   path: '/guider/miniprogram/organization',
  //         // },
  //         // {
  //         //   name: '门店管理',
  //         //   authId: 1168,
  //         //   path: '/guider/miniprogram/storeManagement',
  //         // },
  //         // {
  //         //   name: '应用接入',
  //         //   authId: 1169,
  //         //   path: '/guider/miniprogram/applicationJoin',
  //         // },
  //         {
  //           name: '企业微信授权',
  //           authId: 1177,
  //           path: '/guider/miniprogram/auth',
  //         },
  //         {
  //           name: '企业微信配置',
  //           authId: 1178,
  //           path: '/guider/miniprogram/config',
  //         },
  //         {
  //           name: '支付配置',
  //           authId: 1182,
  //           path: '/guider/miniprogram/applicationJoin',
  //         },
  //         {
  //           name: '提现设置',
  //           authId: 1189,
  //           path: '/guider/miniprogram/withdrawalSettings',
  //         },
  //         {
  //           name: '操作日志',
  //           authId: 1201,
  //           path: '/guider/miniprogram/operationLog',
  //         },
  //         // {
  //         //   name: '下载中心',
  //         //   authId: 1214,
  //         //   path: '/guider/miniprogram/downLoadCenter',
  //         // }
  //       ],
  //     },
  //     {
  //       name: '财务中心',
  //       path: '/guider/financeCenter',
  //       authId: 1186,
  //       // icon: 'iconyingxiaojihua',
  //       routes: [
  //         // {
  //         //   name: '结算记录',
  //         //   authId: 1188,
  //         //   path: '/guider/financeCenter/financeCenter',
  //         // },
  //         {
  //           name: '资金结算',
  //           authId: 1187,
  //           path: '/guider/financeCenter/fundSettlement',
  //         }
  //       ]
  //     }
  //   ],
  // },
  {
    name: '企微助手',
    shortName: '企微',
    path: '/intelligent-marketing/wx-helper',
    authId: 111,
    icon: 'iconqiweizhushou',
    routes: [
      {
        name: '社群运营',
        path: '/intelligent-marketing/wx-helper/group-manage',
        authId: 112,
        // icon: 'iconyingxiaojihua',
        routes: [
          {
            name: '账号绑定',
            authId: 113,
            path: '/intelligent-marketing/wx-helper/group-manage/account-bind',
          },
          {
            name: '社群管理',
            authId: 114,
            path: '/intelligent-marketing/wx-helper/group-manage/manage',
          },
          {
            name: '任务中心',
            authId: 115,
            path: '/intelligent-marketing/wx-helper/group-manage/task',
          },

        ],
      },
      {
        name: 'h5配置',
        path: '/intelligent-marketing/marketing/marketing-manage',
        authId: 116,
        // icon: 'iconyingxiaojihua',
        routes: [
          {
            name: '页面管理',
            authId: 117,
            path: '/intelligent-marketing/marketing/marketing-manage/activity/activity-list',
          },
          {
            name: '页面模板',
            authId: 118,
            path: '/intelligent-marketing/marketing/marketing-manage/activity/templates',
          },
          {
            name: '领券活动',
            authId: 119,
            path: '/intelligent-marketing/marketing/marketing-manage/coupon-activity',
          },
          // h5制作是内部页，无header等页面框架
          // {
          //   name: 'H5制作',
          //   path: '/intelligent-marketing/marketing/marketing-manage/activity/creator',
          // },
        ],
      },
    ],
  },
  {
    name: '设置',
    shortName: '设置',
    path: '/setting',
    authId: 2,
    icon: 'iconyunchashezhi',
    routes: [
      {
        name: '角色管理',
        path: '/main/role',
        authId: 75,
        // icon: 'iconyunchajiaoseguanli',
      },
      {
        name: '账号管理',
        path: '/main/account',
        authId: 76,
        // icon: 'iconyunchazhanghaoguanli',
      },
      {
        name: '支付配置',
        path: '/app-center/configuration/merchant-payment',
        authId: 86,
        // icon: 'iconzhifupeizhi',
      },
      {
        name: '关联线下商户',
        path: '/app-center/configuration/relate-merchant',
        authId: 87,
        // icon: 'iconguanlianxianxiashanghu',
      },
      {
        name: '操作日志',
        path: '/app-center/configure/operation-log',
        authId: 2171,
      },
      // {
      //   name: '渠道管理',
      //   path: '/intelligent-marketing/marketing/channel-manage',
      //   authId: 100,
      //   // icon: 'iconyunchaqudao',
      //   routes: [
      //     {
      //       name: '企业微信',
      //       path: '/intelligent-marketing/marketing/channel-manage/enterp-wx',
      //       authId: 101,
      //       routes: [
      //         {
      //           name: '授权',
      //           path: '/intelligent-marketing/marketing/channel-manage/enterp-wx/auth',
      //           authId: 103,
      //         },
      //         {
      //           name: '配置',
      //           path: '/intelligent-marketing/marketing/channel-manage/enterp-wx/config',
      //           authId: 104,
      //         },
      //       ],
      //     },
      //     {
      //       name: '公众号',
      //       path: '/app-center/channel/vx-config',
      //       authId: 27,
      //     },
      //   ],
      // },
    ],
  },
  {
    name: '全域数据',
    shortName: '全域数据',
    path: '/',
    authId: 1217,
    icon: 'iconyunchashezhi',
    routes: [
      {
        name: '数据看板',
        path: '/dashboard',
        authId: 1218,
      },
    ]
  }
];

const generateRoutes = (routesConfig, parent) => {
  routesConfig.forEach((r) => {
    if (parent) {
      r.parents = (parent.parents || []).concat({
        path: parent.path,
        name: parent.name,
      });
    }
    if (r.routes && r.routes.length > 0) {
      generateRoutes(r.routes, r);
    }
  });
};

generateRoutes(routesConfig);

export default routesConfig;
